import React, { useContext } from "react";
import { UserContext } from "../../utils/userContext";
import { canAccessAdminMenu } from "../../utils/roles";
import AccessDenied from "../ui/AccessDenied";

const withOrganisationAdmin = (WrappedComponent) => {
  return (props) => {
    const { user, isLoading } = useContext(UserContext);
    if (isLoading) return null;
    if (!canAccessAdminMenu(user)) {
      return <AccessDenied message="Access denied. Admin only." />;
    }
    return <WrappedComponent {...props} />;
  };
};

export default withOrganisationAdmin;
